/* Bootstrappers */
import utagBootstrapper from '../utag/utagBootstrapper'
import hBusBootstrapper from '../hBus/hBusBootsrapper';
import webVitalsBootstrapper from '../vitals/webVitalsBootstrapper';

function initPostReduxStoreBoostrappers(initialState) {
  const {
    seoInfo,
  } = initialState.seoState;

  utagBootstrapper.init(seoInfo);
  hBusBootstrapper.init();
  webVitalsBootstrapper.init();
}

export {
  initPostReduxStoreBoostrappers,
}
